import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 2FD284B6-3DC1-4733-B08E-BAD459E87B87
 * name vector-union
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-union.svg
 * tags
 * - Vector 
 * - Geographic Information System 
 */
export const VectorUnionIcon = createSvgIcon(<><path d="M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16H7V20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7H16V3C16,1.89 15.11,1 14,1H3M3,3H14V9H20V20H9V14H3V3Z" /></>, 'VectorUnionIcon');
export default VectorUnionIcon